import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UserProfileDialogComponent } from '../user-profile-dialog/user-profile-dialog.component';
import { SessionRepository } from '@frontend-site/shared/core';
import { SwitchAccountDialogComponent } from '../switch-account-dialog/switch-account-dialog.component';
import { PDialogService } from '@frontend-site/ui/components';
import { UserService } from '@frontend-site/users/domain';
import { AuthenticationService } from '@frontend-site/auth/domain';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'p-user-menu',
    templateUrl: './user-menu.component.html',
    styleUrls: ['./user-menu.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class UserMenuComponent implements OnInit {
    displaySwitchCompany: boolean = false;
    config$ = this.sessionRepository.applicationConfig$;
    isMenuOpen = false;

    constructor(
        private readonly dialog: PDialogService,
        private readonly userService: UserService,
        private readonly sessionRepository: SessionRepository,
        private readonly authentication: AuthenticationService,
        private translate: TranslateService
    ) {
        this.setDisplaySwitchCompany();
    }

    user() {
        const config = { panelClass: 'p-dialog-small' };
        this.dialog.open(UserProfileDialogComponent, config);
    }

    logout(): void {
        this.authentication.logout();
    }

    setDisplaySwitchCompany() {
        this.userService.getCompanies().subscribe((res) => {
            this.displaySwitchCompany = res?.length > 1;
        });
    }

    switchAccount() {
        const config = { panelClass: 'p-dialog-small' };
        this.dialog.open(SwitchAccountDialogComponent, config);
    }

    toggleMenuOpen() {
        this.isMenuOpen = !this.isMenuOpen;
    }

    getUserName(firstName: string, lastName: string): string {
        return `${this.translate.instant('Layouts.Masthead.HELLO_USER')} ${firstName} ${lastName}`;
    }

    ngOnInit(): void {}
}
